import { LINKEDIN_CAMPAIGN_GOALS } from '@bingads-webui-campaign-react/linkedin-utils';

export const generateDefaultCampaignName = (i18n) => {
  let name = '';

  const today = new Date();

  const addz = function (n) {
    if (n < 10) {
      return `0${n}`;
    }
    return `${n}`;
  };

  const time = `${addz(today.getHours())}${addz(today.getMinutes())}${addz(today.getSeconds())}`;
  const date = `${addz(today.getMonth() + 1)}${addz(today.getDate())}${today.getFullYear().toString().slice(2)}`;

  const prefix = i18n.getString(_TL_('LinkedIn Campaign'));
  name = `${prefix}_${date}_${time}`;

  return name;
};

export const getDefaultCampaign = ({
  campaignGoal,
  i18n,
}) => {
  const bidStrategyType = campaignGoal === LINKEDIN_CAMPAIGN_GOALS.MoreBrandAwareness ? 'MaxReach' : 'MaxClicks';

  return {
    Status: 'Paused',
    Name: generateDefaultCampaignName(i18n),
    Budget: {
      Amount: 25, // TODO: This should be configurable based on currency
      Type: 'DailyStandard',
    },
    BiddingScheme: {
      Type: bidStrategyType,
    },
    Languages: ['English'],
    CampaignType: 'LinkedIn',
    CampaignGoal: campaignGoal,
  };
};

export const mapCampaignToBudgetViewModel = (campaign) => {
  const {
    Budget: { Amount },
    BiddingScheme: { Type },
    CampaignSettings = [],
  } = campaign;

  return {
    budgetAmount: Amount,
    bidStrategy: Type,
    campaignGoal: CampaignSettings[0].Goal,
  };
};

export const mapBudgetToCampaignBulkModel = (budget) => {
  const {
    budgetAmount,
    bidStrategy,
  } = budget;

  return {
    Budget: { Amount: budgetAmount },
    BiddingScheme: { Type: bidStrategy },
  };
};
